import { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { getStorageItem, setStorageItem } from '../utils/helpers/storage';

type Args<T> = {
  key: string;
  storage: 'local' | 'session';
  defaultValue: T;
};

function usePersistentState<T>({ key, storage, defaultValue }: Args<T>) {
  const [state, setState] = useState<T>(defaultValue);

  useLayoutEffect(() => {
    const stored = getStorageItem<T>({ key, storage });
    if (stored !== undefined && stored !== null) {
      setState(stored);
    }
  }, [key, storage]);

  const setPersistentState = useCallback(
    (value: T) => {
      setState(value);
      setStorageItem({ key, value, storage });
    },
    [key, storage]
  );

  return [state, setPersistentState] as [T, (value: T) => void];
}

export default usePersistentState;
